<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <form (ngSubmit)="onClickSaveAndClose()" [formGroup]="formGroup" appInvalidControlScroll
          [scrollContainer]="scrollContainer">

        <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'workflows.screens.personCompanyRelation.title' | translate }}</h2>
                <button data-test="B-Close-dialog" mat-icon-button (click)="onClickClose()"
                        [attr.aria-label]="'common.closeDialogAria' | translate" type="button">
                    <mat-icon>close</mat-icon>
                </button>
    </mat-toolbar>

        <div mat-dialog-content #scrollContainer>

            <form-widget-company [canCreate]="false"
                                 headline=""></form-widget-company>

            <mat-divider class="special-divider"></mat-divider>

            <div class="mt-24">
                <mat-form-field appearance="fill" fxFlex="100" floatLabel="always">
                    <mat-label>{{ 'common.notesOptional' | translate }}</mat-label>
                    <textarea matInput data-test="FT-Bemerkungen / Notizen" formControlName="note" rows="3"
                              autocomplete="new-password"></textarea>
                    <mat-error>{{formGroup.get('note').errors | firstErrorMessage}}</mat-error>
                </mat-form-field>
            </div>

            <mat-divider class="special-divider"></mat-divider>

            <ng-container
                    *ngIf="(formGroup.dirty && formGroup.invalid)">
                <u2b-message type="warning" customClass="mt-24">
                    {{ 'workflows.shared.formInvalidHint' | translate }}
                </u2b-message>
            </ng-container>

            <ng-container
                    *ngIf="(formGroup.dirty && formGroup.valid)">
                <u2b-message type="success" customClass="mt-24">
                    <header>{{ 'workflows.shared.formCompleteTitle' | translate }}</header>
                    {{ 'workflows.shared.formCompleteSaveHint' | translate }}
                </u2b-message>
            </ng-container>
        </div>

        <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

            <button data-test="B-Abbrechen" mat-flat-button (click)="onClickClose()" type="button">
                {{ 'common.cancel' | translate }}
            </button>

            <div>
                <ng-template #saving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.saving' | translate }}</span>
                    <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
                </ng-template>

                <ng-template #notSaving>
                    <mat-icon>save</mat-icon>
                    <span>{{ 'common.save' | translate }}</span>
                </ng-template>

                <button type="submit" data-test="B-Speichern" mat-flat-button color="accent"
                        [disabled]="isSaving">
                    <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
                </button>
            </div>

        </div>
    </form>
</div>
